// Copyright (c) 2020 Deere & Company

import './index.scss';
import React, { Component } from 'react';
import AccordionHeader from './header';
import PropTypes from 'prop-types';

class Accordion extends Component {

    state = {
        isExpanded: this.props.isExpanded
    };

    UNSAFE_componentWillReceiveProps ( nextProps ) {

        if ( this.props.isExpanded !== nextProps.isExpanded ) {

            this.setState( {
                isExpanded: nextProps.isExpanded
            } );

        }

    }

    handleClick = () => {

        this.setState( {
            isExpanded: !this.state.isExpanded
        } );

        if ( this.props.onClick ) {

            this.props.onClick( !this.state.isExpanded );

        }

    };

    render = () => {

        const isOpenClassName = this.state.isExpanded ?
            'is-open' :
            'is-closed';

        const accordionClassName = `accordion ${this.props.accordionId} ${isOpenClassName}`;

        return (
            <section className={accordionClassName}>
                <AccordionHeader
                    isExpanded={this.state.isExpanded}
                    onClick={this.handleClick}
                    secondaryText={this.props.secondaryText}
                    title={this.props.title}
                    subTitle={this.props.subTitle}
                />
                {this.state.isExpanded && <div className="accordion-body">{this.props.children}</div>}
            </section>

        );

    }

}

Accordion.displayName = 'Accordion';
Accordion.propTypes = {
    accordionId: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    isExpanded: PropTypes.bool,
    onClick: PropTypes.func,
    secondaryText: PropTypes.string,
    title: PropTypes.node.isRequired,
    subTitle: PropTypes.node
};
Accordion.defaultProps = {
    isExpanded: false
};

export default Accordion;
